export default __webpack_public_path__ + "static/media/default.dee2aab5ce22280a87ad030c8c2b0390.png";